const getExternalStaffQuery = (version, assessorIds) => {
    return `query ExternalStaffQuery {
        getStaffInfo_${version}(staff_uids: "${assessorIds}") {
          uid: staffUid 
          firstName
          lastName
        }
      }`;
};

export default getExternalStaffQuery;
